import { useEffect, useState, useRef, useCallback } from "react";

const style = {
  item: `rounded-t w-full hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap text-left border-b-2 border-gray-100 text-black`,
  menu: `block z-50 w-full shadow rounded absolute top-0 left-0 bg-white float-left py-1 px-0 text-left border border-gray-300 rounded-sm mt-0.5 mb-0 mx-0 bg-clip-padding`,
};

const Dropdown = ({ children, testId }) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const toggle = useCallback(() => {
    setShow((prevState) => !prevState);
  }, []);

  // close dropdown when you click outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!ref.current?.contains(event.target)) {
        if (!show) return;
        setShow(false);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [show, ref]);

  // close dropdown when you click on "ESC" key
  useEffect(() => {
    const handleEscape = (event) => {
      if (!show) return;

      if (event.key === "Escape") {
        setShow(false);
      }
    };
    document.addEventListener("keyup", handleEscape);
    return () => document.removeEventListener("keyup", handleEscape);
  }, [show]);

  /* First child contains the dropdown toggle */
  const dropdownToggle = children[0];

  /* Second child contains the dropdown menu */
  const dropdownMenu = children[1];
  return (
    <>
      <button
        data-testid={testId}
        className="bg-white hover:bg-gray-100 text-gray-800 border border-gray-400 shadow font-semibold py-2 px-1 rounded inline-flex items-center"
        onClick={toggle}
        type="button"
        aria-expanded="true"
        aria-haspopup="true"
      >
        {dropdownToggle}
      </button>
      {show && <>{dropdownMenu}</>}
    </>
  );
};

const DropdownToggle = ({ children }) => {
  return <>{children}</>;
};

const DropdownMenu = ({ children }) => {
  return (
    <div className="relative" data-testid="dropdown_menue-test">
      <div
        style={{ transform: "translate3d(0px, 3px, 0px)" }}
        className={style.menu}
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        {children}
      </div>
    </div>
  );
};

const DropdownItem = ({ children, value, onSelect }) => {
  return (
    <button
      tabIndex={0}
      className={style.item}
      role="menuitem"
      onClick={() => {
        onSelect(value);
      }}
    >
      {children}
    </button>
  );
};

export { Dropdown, DropdownToggle, DropdownMenu, DropdownItem };
